import {useAxios} from '@sttedra_ui/framework';


const {base} = useAxios();

export default function() {
  const PREVIEW_PREFIX = STTEDRA_CUSTOM_PREVIEW_PREFIX;
  base.interceptors.request.use((config) => {
    if (!window.location.host.startsWith(PREVIEW_PREFIX)) {
      return config;
    }

    config.baseURL = config.baseURL.replace('://', `://${PREVIEW_PREFIX}`);
    return config;
  });
}
